export default __webpack_public_path__ + "static/media/area-2.a8205a03.png";